<template>
  <div id="pageHeader">
    <PageHeader1XP ref="pageHeader1XPRef" :geo-i-p="geoIpConfig" />
  </div>
  <div>
    <main id="main">
      <div id="heroSlider-6614" class="heroSlider">
        <HeroSlider :class="$style.heroSlider" :slides="slides" />
      </div>
      <div class="columns StartPage__contentGrid">
        <div id="row" class="MicrositePlaceholder__anchor"></div>
        <div class="column is-full">
          <div class="Button__orange Button__center Button__button">
            <button
              onclick="window.open('https://www.wika.com/de-de/product_advisor.WIKA', '_self'); return false;"
              type="button"
            >
              Benötigen Sie Hilfe? Testen Sie unseren Product Advisor
            </button>
          </div>
        </div>
      </div>
      <div :class="[$style.contentGrid, $style.WebStart1XP, 'columns']">
        <div id="reihe" class="MicrositePlaceholder__anchor"></div>
        <div class="column is-one-third">
          <ContentTeaserS
            :category="exampleTeaser1.category"
            :image="exampleTeaser1.image"
            :is-video="false"
            :link-title="exampleTeaser1.linkTitle"
            primary-link="#"
            :primary-link-new-window="true"
            secondary-link="#"
            :secondary-link-new-window="false"
            :wt-params="exampleTeaser1.wtParams"
          />
        </div>
        <div class="column is-one-third">
          <ContentTeaserS
            :category="exampleTeaser2.category"
            :image="exampleTeaser2.image"
            :is-video="true"
            :link-title="exampleTeaser2.linkTitle"
            :primary-link="exampleTeaser2.primaryLink"
            :primary-link-new-window="false"
            secondary-link="#"
            :secondary-link-new-window="false"
            :wt-params="exampleTeaser2.wtParams"
          />
        </div>
        <div class="column is-one-third">
          <SalesContainer :config="salesContainerConfig" />
        </div>
      </div>
      <div :class="[$style.eventGrid, $style.WebStart1XP, 'columns']">
        <div id="st_row_1" class="MicrositePlaceholder__anchor"></div>
        <div
          v-for="(event, index) in events"
          :key="index"
          :class="[
            'column',
            index % 2 === 0 && index === events.length - 1 && 'is-full-tablet',
            'is-one-third-desktop',
          ]"
        >
          <EventTeaser :data="event" />
        </div>
      </div>
      <div :class="[$style.contentGrid, $style.WebStart1XP, 'columns']">
        <div id="st_row_2" class="MicrositePlaceholder__anchor"></div>
        <div class="column is-two-thirds">
          <ContentTeaserM
            :category="exampleTeaser3.category"
            :image="exampleTeaser3.image"
            :is-video="false"
            :link-title="exampleTeaser3.linkTitle"
            primary-link="#"
            :primary-link-new-window="true"
            secondary-link="#"
            :secondary-link-new-window="false"
            :text="exampleTeaser3.text"
            :wt-params="exampleTeaser3.wtParams"
          />
        </div>
        <div class="column is-one-third">
          <figure class="ContentOverviewTeaser__container">
            <a
              class="ContentOverviewTeaser__mediaLink"
              href="https://t38.wika.com/de/t38.WIKA"
              target="_blank"
            >
              <img
                alt="T38"
                height="415"
                src="https://wika-www.qa.etecture.de/media/Images/Exhibition_738x410/livewebinart38_en_co_rs_w738_h415_image.jpg"
                width="738"
              />
            </a>
            <figcaption>
              <a href="https://t38.wika.com/de/t38.WIKA" target="_blank">
                <h3>Entdecken Sie unseren neuen Universal-Temperaturtransmitter T38.</h3>
              </a>
            </figcaption>
          </figure>
        </div>
      </div>
    </main>
    <FloatingContact />
    <Footer1XP v-bind="footer" />
    <CookieDisclaimer :config="cookieDisclaimerConfig" />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import ContentTeaserM from '../ContentTeaserM/ContentTeaserM.vue';
import ContentTeaserS from '../ContentTeaserS/ContentTeaserS.vue';
import Footer1XP from '../Footer1XP/Footer1XP.vue';
import HeroSlider from '../HeroSlider/HeroSlider.vue';
import EventTeaser from '../EventTeaser/EventTeaser.vue';
import SalesContainer from '../SalesContainer/SalesContainer.vue';
import CookieDisclaimer from '../CookieDisclaimer/CookieDisclaimer.vue';
import PageHeader1XP from '../PageHeader1XP/PageHeader1XP.vue';
import { useHeaderStore } from '../../store/headerState/headerState.ts';
import FloatingContact from '../FloatingContact/FloatingContact.vue';

const headerStore = useHeaderStore();

defineProps({
  footer: {
    Type: Object,
    default: () => {},
  },
  geoIpConfig: {
    default: undefined,
  },
  salesContainerConfig: {
    default: undefined,
  },
  slides: {
    default: undefined,
  },
  productLinks: {
    default: undefined,
  },
  events: {
    default: undefined,
  },
  cookieDisclaimerConfig: {
    default: undefined,
  },
  exampleTeaser1: {
    default: undefined,
  },
  exampleTeaser2: {
    default: undefined,
  },
  exampleTeaser3: {
    default: undefined,
  },
  exampleTeaser4: {
    default: undefined,
  },
});

const isHeaderOpen = ref(false);
const pageHeader1XPRef = ref(null);

watch(
  () => headerStore.isHeaderOpen,
  (newValue, oldValue) => {
    if (newValue !== oldValue) {
      isHeaderOpen.value = newValue;
    }
  },
);
</script>

<style module lang="scss">
@forward './StartPage.scss';
</style>
